import axios from "axios"
import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import { useEffect, useState } from "react"
import styled from "styled-components"

import { FaRegTrashCan } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
import { useModal } from "../../contexts/ModalContext"
import ModalNewEmail from "./ModalNewEmail"
import ModalDeleteEmail from "./ModalDeleteEmail"

const Container = styled.div`
    width: 100%;
`
const Titulo = styled.p`
    margin: 0;
    font-size: 15px;
    color: #000;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    margin-bottom: 15px;
`
const ContainerTable = styled.div`
    width: 100%;
`
const Tabela = styled.table`
    width: 100%;
    border: 1.5px solid #d8d8d8;
    border-collapse: collapse;
    box-sizing: border-box;
    & tr{
        height: 40px;
    }
    & th{
        color: #000;
        text-align: left;
        padding-left: 10px;
        border: 1.5px solid #d8d8d8;
        background-color: #f1f1f1;
    }
    & td{
        color: #000;
        border: 1.5px solid #d8d8d8;
    }
`
const CellDelete = styled.td`
    width: 40px;
`
const ContainerDelete = styled.div`
    width: 30px;
    height: 30px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const IconeLixo = styled(FaRegTrashCan)`
    width: 20px;
    height: 20px;
    color: #ff0000;
    cursor: pointer;
`
const LinhaAdicionar = styled.td`
    padding: 0 15px;
`
const ContainerLinhaAdd = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
`
const BotaoAdd = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    margin: auto 0;
    color: #00b400;
    background-color: transparent;
    border: none;
    gap: 5px;
    cursor: pointer;
    transition: .3s;
    &:hover{
        color: #00e200;
    }
`
const IconeMais = styled(FaPlus)`
    width: 12px;
    height: 12px;
`
const TextAdd = styled.p`
    margin: 0;
    font-weight: bold;
`

const ModalEmails = ({ centro_custo, ano, fecharModal }) => {

    const { openModal, isModalOpen, closeModal } = useModal();

    const [emails, setEmails] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {

        setLoading(true);

        try {
            const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Cipa/GetEmails/index.php?ano=${ano}&cc=${centro_custo}`)
            setEmails(data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        fetchData();
    }, [])

    const addEmail = () => {
        openModal('addEmail');
    }

    const closeAddEmail = async () => {
        closeModal();
        fetchData();
    }

    const [selectedEmail, setSelectedEmail] = useState(null);

    const openDelete = (item) => {

        setSelectedEmail(item);
        openModal('confirmDeleteModal');

    }

    const closeDelete = () => {
        setSelectedEmail(null);
        closeModal();
    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeModal} >
                    <Container>
                        <Titulo> Lista de e-mails: </Titulo>
                        <ContainerTable>
                            <Tabela>
                                <thead>
                                    <tr>
                                        <th>E-MAIL</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loading ? (
                                            <tr>
                                                <td colSpan={2} >CARREGANDO...</td>
                                            </tr>
                                        ) : emails.map((obj) => (
                                            <tr key={obj.id} >
                                                <td style={{ paddingLeft: '12px' }}>{obj.email}</td>
                                                <CellDelete>
                                                    <ContainerDelete>
                                                        <IconeLixo
                                                            onClick={() => openDelete(obj)}
                                                        />
                                                    </ContainerDelete>
                                                </CellDelete>
                                            </tr>
                                        ))}
                                    <LinhaAdicionar colSpan={2} >
                                        <ContainerLinhaAdd>
                                            <BotaoAdd
                                                onClick={() => addEmail()}
                                            >
                                                <IconeMais />
                                                <TextAdd>
                                                    NOVO E-MAIL
                                                </TextAdd>
                                            </BotaoAdd>
                                        </ContainerLinhaAdd>
                                    </LinhaAdicionar>
                                </tbody>
                            </Tabela>
                        </ContainerTable>
                    </Container>
                </Modal>
            </Overlay >
            {
                isModalOpen('addEmail') && (
                    <ModalNewEmail
                        centro_custo={centro_custo}
                        ano={ano}
                        fecharModal={closeAddEmail}
                    />
                )
            }
            {
                isModalOpen('confirmDeleteModal') && (
                    <ModalDeleteEmail
                        item={selectedEmail}
                        fecharModal={closeDelete}
                        atualizar={fetchData}
                    />
                )
            }
        </>
    )
}

export default ModalEmails;